<template>
    <QResourceMenu :links="links" />
</template>
<script>
import QResourceMenu from './QResourceMenu';

export default {
    components: {
        QResourceMenu,
    },

    computed: {
        links() {
            var links = [];
            var g = this;
            if (this.tenantHasFeature('OptCRM')) {
                links.push({
                    label: 'Opt!',
                    hex_color: '#360568',
                    icon: 'icon-q-leads',
                    function: 'OptSSO',
                })
            }

            this.user.nav_menu.forEach(function(item) {
                if (g.current_tenant.ID == item.tenant_id && item.menu == 'App Menu') {
                    var _item = { ...item }
                    links.push(_item);
                }
            })



            if (this.tenantHasFeature('QuilityShop')) {
                links.push({
                    label: 'Quility Store',
                    hex_color: '#360568',
                    icon: 'icon-q-shopping',
                    function: 'showShopPreludeDialog',
                })
            }
            return links
        },
    },
};
</script>